// removed by extract-text-webpack-plugin
module.exports = {"skip-auth-section":"SkipAuthentication__skip-auth-section","skipAuthSection":"SkipAuthentication__skip-auth-section"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/SkipAuthentication/SkipAuthentication.scss
// module id = 1489
// module chunks = 8